import { Component } from 'react';
import DataTable from '../../../../../components/Datatable';
import Loading from '../../../../../components/Loading';
import { COLUMNS } from './keys';
import { getSortKeys, setAdditionalStyles } from '../../../../../helpers/table';
import { withTranslation } from 'react-i18next';
import { query } from './query';
import { v4 as uuid } from 'uuid';
import { normalizeDomain } from '../../../../../helpers/normalizeDomain';

class AllLinks extends Component {
    constructor() {
        super();

        this.getData = this.getData.bind(this);
        this.forceRun = this.forceRun.bind(this);

        this.state = {
            data: [],
            loading: true,
        };
    }

    async getData({ force = false, alreadyInQueue = false }) {
        try {
            this.query = query({
                prompt_uids: this.props.prompt_uids,
                platforms: this.props.platforms,
            });

            this.setState({ loading: true });

            this.query.bind(this.setState.bind(this));
            const results = await this.query.update({ force, alreadyInQueue });
            const data = results?.map((x) => ({ id: uuid(), ...x }));
            this.setState({
                data,
                loading: false,
            });

            if (this.props.setOwnValue) {
                const ownAvgPosition =
                    data.find(
                        (item) =>
                            normalizeDomain(item.domain) ===
                            normalizeDomain(this.props.project?.own_domain),
                    )?.avgPosition ?? 0;
                this.props.setOwnValue(ownAvgPosition);
            }
        } catch (err) {
            console.log(err);
        }
    }

    forceRun() {
        this.getData({ force: true, alreadyInQueue: true });
    }

    async componentDidUpdate(prevProps) {
        if (
            !this.props.globalLoading &&
            this.props.globalLoading !== prevProps.globalLoading &&
            !this.props.prompt_uids?.length
        ) {
            this.setState({ data: [], loading: false });
        }
        if (
            JSON.stringify(prevProps.prompt_uids) !== JSON.stringify(this.props.prompt_uids) ||
            JSON.stringify(prevProps.platforms) !== JSON.stringify(this.props.platforms)
        ) {
            this.getData({});
        }

        if (this.props.updateAll !== prevProps.updateAll) {
            this.forceRun();
        }
    }

    searchFunction(data, search) {
        if (!search) return data;
        return data.filter((item) => item.title?.toLowerCase().includes(search.toLowerCase()));
    }

    render() {
        const { t } = this.props;

        return (
            <div className="card table-main rounded-main ">
                {this.state.loading && <Loading padding={10} />}
                {!this.state.loading && (
                    <DataTable
                        nodes={this.state.data ?? []}
                        sortFns={getSortKeys(COLUMNS(t))}
                        searchFunction={this.searchFunction}
                        COLUMNS={COLUMNS(t)}
                        header={t('ai_tracking.keyword_detail.urls.header')}
                        customEmptyMessage={t('global.no_data')}
                        uniqKey={'url'}
                        defaultSortKey={'ranking_share'}
                        additionalStyles={setAdditionalStyles(COLUMNS(t))}
                        forceRun={this.forceRun}
                    />
                )}
            </div>
        );
    }
}

export default withTranslation()(AllLinks);
